export default {
  "footer": "_footer_1478sm",
  "text": "_text_1478sm",
  "icon": "_icon_1478sm"
};
